import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mail, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { getConfig, waLink } from "@/lib/api";
import { FOOTER } from "@/constants/testIds";

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [config, setConfig] = useState({ company_email: "", company_whatsapp: "" });

  useEffect(() => {
    getConfig().then(setConfig).catch(() => {});
  }, []);

  const go = (id) => {
    if (location.pathname !== "/") navigate("/#" + id);
    else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid={FOOTER.section} className="border-t border-border bg-secondary/40">
      <div className="container-x py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center rounded-2xl bg-white p-2 shadow-sm ring-1 ring-black/5">
                <img src="/logo.png" alt="controllatelefoni.it" className="h-16 w-16 object-contain" />
              </span>
            </div>
            <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
              Soluzione professionale di controllo parentale per dispositivi Android. Sicurezza della famiglia e uso trasparente, nel pieno rispetto della legge.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">Prodotto</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><button onClick={() => go("funzionalita")} className="hover:text-foreground transition-colors">Funzionalità</button></li>
              <li><button onClick={() => go("come-funziona")} className="hover:text-foreground transition-colors">Come funziona</button></li>
              <li><Link to="/shop" className="hover:text-foreground transition-colors">Shop Telefoni</Link></li>
              <li><button onClick={() => go("prezzi")} className="hover:text-foreground transition-colors">Prezzi</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">Legale</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/termini" className="hover:text-foreground transition-colors">Termini e Condizioni</Link></li>
              <li><Link to="/uso-lecito" className="hover:text-foreground transition-colors">Uso Lecito e Consenso</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">Contatti</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              {config.company_email && (
                <li className="flex items-center gap-2">
                  <Mail className="h-4 w-4 text-accent" />
                  <a href={`mailto:${config.company_email}`} className="hover:text-foreground transition-colors break-all">{config.company_email}</a>
                </li>
              )}
              {config.company_whatsapp && (
                <li className="flex items-center gap-2">
                  <MessageCircle className="h-4 w-4 text-accent" />
                  <a href={waLink(config.company_whatsapp, "Ciao! Vorrei informazioni su controllatelefoni.it")} target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">{config.company_whatsapp}</a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} controllatelefoni.it — Tutti i diritti riservati.</p>
          <p className="text-xs text-muted-foreground max-w-2xl sm:text-right">
            L'utilizzo del servizio è consentito solo su dispositivi di proprietà o con il consenso esplicito dell'utilizzatore. È vietato ogni uso illecito. In caso di uso illecito, controllatelefoni.it collaborerà con le forze dell'ordine locali per le indagini e le attività volte a individuare l'utilizzatore. Si declina ogni responsabilità: acquistando il prodotto l'acquirente dichiara di aver preso visione di tutte le normative vigenti in Italia.
          </p>
        </div>
      </div>
    </footer>
  );
};
